const STORAGE_KEY = "nema_caregiver_preferences_v1";
const VIEWED_KEY = "nema_caregiver_viewed_v1";

export function readStoredCaregiverPreferences() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function writeStoredCaregiverPreferences(list) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Array.isArray(list) ? list : []));
  } catch {
    /* ignore quota errors */
  }
}

export function preferenceIdsFromList(preferences) {
  if (!Array.isArray(preferences)) return [];
  return preferences
    .map((p) => Number(p?.id))
    .filter((n) => Number.isFinite(n) && n > 0)
    .slice(0, 3);
}

export function readViewedCaregivers() {
  try {
    const raw = sessionStorage.getItem(VIEWED_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function recordViewedCaregiver(caregiver) {
  if (!caregiver?.id) return;
  try {
    const existing = readViewedCaregivers().filter((c) => String(c.id) !== String(caregiver.id));
    const entry = {
      id: caregiver.id,
      name: caregiver.name || "Caregiver",
      rating: caregiver.rating ?? null,
      reviewCount: caregiver.reviewCount ?? 0,
      designation: caregiver.designation || "Care Attendant",
      years: caregiver.years ?? caregiver.experience_years ?? null,
      isAvailable: caregiver.isAvailable !== false,
    };
    sessionStorage.setItem(VIEWED_KEY, JSON.stringify([entry, ...existing].slice(0, 12)));
  } catch {
    /* ignore quota errors */
  }
}
